import _ from "lodash";

import numeral from "numeral";
import CompanyImportModel from "../../../views/accounting/company/department/CompanyImport.model";
import { SheetException } from "./DepartmentUploadExcel.exceptions";

export class DepartmentUploadExcel {
    constructor({ XlsxAdapter } = {}) {
        this.XlsxAdapter = XlsxAdapter;

        this.sheets = [];
        this.sheetModels = [];
    }
    /**
     * Executa o carregamento dos arquivos.
     * @public
     * @param {array} files
     * @returns {array}
     */
    async exec({ files }) {
        this.sheets = [];
        this.sheetModels = [];

        for (const file of files) {
            await this._processFile({ file });
        }

        if (!this.sheets.length) {
            throw new SheetException("Planilha inválida");
        }

        this.sheets.forEach((sheet) => {
            const accountingId = this.getAccountingId(sheet);
            const companyId = this.getCompanyId(sheet);
            const source = this.getSource(sheet);
            const year = this.getYear(sheet);
            const serieIds = this.getSerieIdsByCompany(sheet);
            const points = this.getPointsByCompanySheet(sheet);

            const companyImportModel = new CompanyImportModel({
                accountingId,
                companyId,
                source,
                year,
                serieIds,
                points
            });

            if (this.isValidSheet(sheet))
                this.sheetModels.push(companyImportModel);
        });

        if (!this.sheetModels.length)
            throw new SheetException("Planilha inválida");

        return this.sheetModels;
    }

    async _processFile({ file }) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.onload = (e) => {
                const _parseUint8ToCharCode = (arrayBuffer) => {
                    const charCodes = [];
                    const data = new Uint8Array(arrayBuffer);

                    for (let i = 0; i <= data.length; ++i) {
                        charCodes[i] = String.fromCharCode(data[i]);
                    }

                    return charCodes;
                };

                const charCodes = _parseUint8ToCharCode(fileReader.result);

                const bstr = charCodes.join("");
                const workbook = this.XlsxAdapter.read(bstr, {
                    type: "binary",
                    raw: true,
                    cellNF: true,
                    cellFormula: true,
                    cellStyles: true
                });

                _.forEach(workbook.Sheets, (values, key) => {
                    if (key != "Capa" && key != "Instruções")
                        this.sheets.push(
                            this.XlsxAdapter.sheetToJson(values, {
                                header: 1,
                                blankrows: false
                            })
                        );
                });

                resolve(true);
            };

            fileReader.readAsArrayBuffer(file);
        });
    }

    getAccountingId(companySheet) {
        return companySheet[0][13]; // linha 1; coluna N
    }

    getCompanyId(companySheet) {
        return companySheet[0][9]; // linha 1; coluna j
    }

    getSource(companySheet) {
        return companySheet[0][10]; // linha 1; coluna k
    }

    getYear(companySheet) {
        return companySheet[0][11]; // linha 1; coluna l
    }

    getSerieIdsByCompany(companySheet) {
        let serieIds = [];
        for (let row = 3; row < companySheet.length; row++) {
            const serieSheet = companySheet[row];
            serieIds.push(serieSheet[14]);
        }

        return serieIds;
    }

    getPointsByCompanySheet(companySheet) {
        let points = [];

        const _numberToJSFormat = (num) => {
            num = num.replace(/\./g, "");
            num = num.replace(/\,/g, ".");
            return num;
        };

        for (let row = 3; row < companySheet.length; row++) {
            const companyId = this.getCompanyId(companySheet);
            const serieRowSheet = companySheet[row];
            const serieIdSheet = serieRowSheet[14];
            const serieNatureOfAccount = serieRowSheet[15];
            const monthsCells = serieRowSheet.slice(2, 14);

            // isNaN(value)
            //     ? 0
            //     : serieNatureOfAccount == "negative"
            //     ? -Math.abs(value)
            //     : value;

            monthsCells.forEach((value, month) => {
                let valueResult = 0;

                if (typeof value === "string" && value.match(/[$R%]/g)) {
                    const newValue = value.replace(/[$R%]/gi, "");

                    const numJsFormtString = _numberToJSFormat(newValue);

                    const numJS = numeral(numJsFormtString).value();

                    valueResult =
                        serieNatureOfAccount == "negative"
                            ? -Math.abs(numJS)
                            : numJS;
                } else if (isNaN(value)) {
                    valueResult = 0;
                } else {
                    valueResult =
                        serieNatureOfAccount == "negative"
                            ? -Math.abs(value)
                            : value;
                }

                let point = {};
                point.companyId = companyId;
                point.serieId = serieIdSheet;
                point.value = valueResult;
                point.month = month;

                points.push(point);
            });
        }

        return points;
    }

    isValidSheet(sheet) {
        return sheet[0][12] === "MODELO OFICIAL"; // M1 = MODELO OFICIAL
    }
}
